var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.135 2C6.015 2.449 2 6.747 2 11.982c0 5.534 4.486 10.02 10.02 10.02 5.235 0 9.533-4.017 9.98-9.136h-2.518a7.516 7.516 0 11-8.347-8.347V2.001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.482 11.097H22a9.975 9.975 0 00-2.3-5.548l-1.78 1.78a7.478 7.478 0 011.561 3.768zM12.903 2a9.975 9.975 0 015.548 2.3l-1.78 1.78a7.478 7.478 0 00-3.768-1.56V2zm.407 10.691a1.473 1.473 0 11-2.001-2.001l-.002-.003 4.543-2.539-2.54 4.543z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOutline);
export default __webpack_public_path__ + "82e05785d8bb573fa212cf4538ba4e44.svg";
export { ForwardRef as ReactComponent };